export default __webpack_public_path__ + "static/hochzeitsfotos-berlin-brandenburg-potsdam-claudia_nuernberger-d910da8b379e8dc825d81f31d12d2a4d.jpg";